import { Routes } from '@angular/router';
import { AfisureLandingComponent } from './components/template/afisure-landing/afisure-landing.component';
import { WhatsappLoginComponent } from './components/template/whatsapp-login/whatsapp-login.component';
import { ThankYouPageComponent } from './components/swiftB2C/thank-you-page/thank-you-page.component';


export const routes: Routes = [
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  { path: 'error', loadChildren: () => import('./routers/dialog-box-routing.module').then(m => m.DialogBoxRoutingModule) },
  { path: 'view', loadChildren: () => import('./routers/view-routing-module').then(m => m.ViewRoutingModule) },
  { path: 'quotes', loadChildren: () => import('./routers/swiftB2Cquotation-routing-module').then(m => m.SwiftB2cQuotationRoutingModule) },
  { path: 'landing', component: AfisureLandingComponent },
    {path:'thank-you',component:ThankYouPageComponent},
  { path: 'verification/:accessCode', component: WhatsappLoginComponent },
  { path: '**', redirectTo: 'landing', pathMatch: 'full' }, // Redirects to HomeComponent


]
